var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",class:{ 'nav-open': _vm.$sidebar.showSidebar }},[_c('notifications'),_c('sidebar-fixed-toggle-button'),_c('side-bar',{attrs:{"background-color":_vm.sidebarBackground,"short-title":"TH","title":"Tillered Hub","homeLink":"/home"}},[_c('template',{slot:"links"},[_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('sidebar.dashboard'),
        icon: 'tim-icons icon-chart-pie-36',
        path: '/home/dashboard'
      },"active":_vm.storeUserProfile.hasCompany()}}),_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('sidebar.nodes'),
        icon: 'tim-icons icon-tv-2',
        path: '/home/nodes'
      }}}),_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('sidebar.networks'),
        icon: 'tim-icons icon-vector',
        path: '/home/networks'
      }}}),_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('sidebar.organisation'),
        icon: 'tim-icons icon-molecule-40',
        path: '/home/organisations/all'
      }}}),_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('sidebar.profile'),
        icon: 'tim-icons icon-badge',
        path: '/home/profile'
      }}})],1)],2),_c('div',{staticClass:"main-panel",attrs:{"data":_vm.sidebarBackground}},[_c('dashboard-navbar'),_c('router-view',{attrs:{"name":"header"}}),_c('div',{class:{ content: !_vm.$route.meta.hideContent },on:{"click":_vm.toggleSidebar}},[_c('zoom-center-transition',{attrs:{"duration":200,"mode":"out-in"}},[_c('router-view')],1)],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }